import React from 'react';
const PageTitle = props => /*#__PURE__*/React.createElement("div", {
  className: "align-self-center"
}, /*#__PURE__*/React.createElement("h2", {
  id: "wm_page_title"
}, props.title), /*#__PURE__*/React.createElement("div", {
  className: "text-muted"
}, props.subtitle), /*#__PURE__*/React.createElement("br", null));
export default PageTitle;